import { z } from "zod";
import { reviewJobStatusSchema } from "../enums.js";
import { isoDate } from "./common.js";

export const queueJobIssueSchema = z.object({
  jobId: z.string(),
  reviewId: z.string(),
  title: z.string(),
  jobStatus: reviewJobStatusSchema,
  /** LEASE_EXPIRED means a worker claimed the job and stopped renewing its lease. */
  kind: z.enum(["FAILED", "LEASE_EXPIRED", "RETRY_EXHAUSTING"]),
  attempts: z.number().int().nonnegative(),
  maxAttempts: z.number().int().positive(),
  waitingSeconds: z.number().int().nonnegative(),
  lastError: z.string().nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
});
export type QueueJobIssue = z.infer<typeof queueJobIssueSchema>;

export const queueHealthSchema = z.object({
  pending: z.number().int().nonnegative(),
  running: z.number().int().nonnegative(),
  retrying: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  /** How long the longest-waiting unstarted job has been queued. */
  oldestWaitingSeconds: z.number().int().nonnegative().nullable(),
  /** Submission to completion, averaged over recently finished jobs. */
  averageTurnaroundSeconds: z.number().int().nonnegative().nullable(),
  completedLastHour: z.number().int().nonnegative(),
  concurrencyLimit: z.number().int().positive(),
  leaseSeconds: z.number().int().positive(),
  issues: z.array(queueJobIssueSchema),
  generatedAt: isoDate,
});
export type QueueHealth = z.infer<typeof queueHealthSchema>;
